import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/** Matches legacy `UserNotificationModelApi`. */
export interface UserNotificationModel {
  IsEnabled: boolean;
  Start: string | null;
  End: string | null;
  Content: string | null;
}

/** Matches legacy `UpdateUserNotificationRequestApi`. */
export interface UpdateUserNotificationRequest {
  IsEnabled: boolean;
  Start: string | null;
  End: string | null;
  Content: string | null;
}

/** Ports legacy `UserNotificationApiService` — backs the admin-only
 *  `UserNotificationComponent` and the app-wide `UserNotificationBannerComponent`. */
@Injectable({ providedIn: 'root' })
export class UserNotificationApiService {
  private readonly http = inject(HttpClient);

  /** GET /UserNotifications */
  get(): Observable<UserNotificationModel | null> {
    return this.http.get<UserNotificationModel | null>(`${environment.apiBaseUrl}/UserNotifications`);
  }

  /** PATCH /UserNotifications */
  update(model: UpdateUserNotificationRequest): Observable<void> {
    return this.http.patch<void>(`${environment.apiBaseUrl}/UserNotifications`, model);
  }
}
